// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"521":"errors-404","795":"error-403","852":"errors-500","945":"dashboard","954":"configurations","966":"login"}[chunkId] || chunkId) + "." + {"521":"75a41993","795":"e85e6a2e","852":"6df7c987","905":"1532ba10","945":"b8de1b5c","954":"796865f1","966":"33a04a6a"}[chunkId] + ".js";
};